import React from 'react';
import { Dialog, DialogContent } from '@mui/material';
import DispatchForm from './dispatchEntryForm';

const AddDispatchEntryModal = ({ open, handleClose , mode = "Add", formDataProp = {}, fetchDispatches }) => {
    return (
        <Dialog 
            open={open} 
            onClose={handleClose} 
            maxWidth="xl" 
            fullWidth
        >
            <DialogContent>
                <DispatchForm handleClose={handleClose} mode={mode} formDataProp = {formDataProp} fetchDispatches ={fetchDispatches}/>
            </DialogContent>
        </Dialog>
    );
};

export default AddDispatchEntryModal;